// extracted by mini-css-extract-plugin
module.exports = {"errorMessageSlot":"ErrorMessageSlot_errorMessageSlot__IcZTJ","addToBag":"ErrorMessageSlot_addToBag__LOBfy"};